const styles = {
  btn: {
    display: "flex",
    gap: "2rem",
    marginTop: "3rem",
  },
};

export default styles;
